import { TrialBalanceV1 } from "../../grader/trial-balance-sheet/v1.grader";
import { AnswerConfig } from "../../grader/grade-input";
import { ExtractInput } from "../extract-input";
import { ExtractOutput } from "../extract-output";
import { extractTable } from "../utils/extract-table";
import { extractValueAndConfigFromCell } from "../utils/extract-value-from-cell";

export function extractTrialBalanceV1(
  extractInput: ExtractInput,
): ExtractOutput<TrialBalanceV1[]> {
  const { div, version, questionType } = extractInput;
  const table = extractTable(div, "table.trial-balance");
  if (!table) throw new Error("테이블을 만들어주세요.");
  const trs = table.getElementsByTagName("tr");

  const trialBalances: TrialBalanceV1[] = [];
  for (const tr of Array.from(trs).slice(3)) {
    const tds = tr.getElementsByTagName("td");
    if (tds.length === 0) throw new Error("테이블 column을 확인해주세요.");
    if (!tds[0]) throw new Error("알수없는 문제가 생겼습니다.");

    const { value: name } = extractValueAndConfigFromCell(tds[0]);
    const values: string[] = [];
    const answerConfigs: (AnswerConfig | undefined)[] = [];

    Array.from(tds)
      .slice(1)
      .forEach((td) => {
        const { value, answerConfig } = extractValueAndConfigFromCell(td);
        values.push(value);
        answerConfigs.push(answerConfig);
      });

    trialBalances.push({
      id: tr.id,
      name,
      values,
      isInput: false,
      answerConfigs,
    });
  }

  return {
    version,
    questionType,
    entryCount: trialBalances.length, // 추출된 행 수
    answerSheet: trialBalances, // 추출된 현금흐름표 데이터
  };
}
